import React from 'react';
import Schema from 'components/Schema';
import PropTypes from 'prop-types';

const FaqSchema = ({ faqs }) => {
  if (!faqs || !faqs.length) {
    return null;
  }
  const faqsLD =
    faqs &&
    faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answerContent[0].content || faq.answerContent[0].text,
      },
    }));
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqsLD,
  };
  return <Schema data={schema} />;
};

FaqSchema.propTypes = {
  faqs: PropTypes.array,
};
FaqSchema.defaultProps = {
  faqs: null,
};

export default FaqSchema;
